export default function reducer(state = {
    loading: false,
    redux: false,
    alert: { show: false, message: "", variant: null }
}, action) {
    switch (action.type) {
        case "LOADING_START": {
            return { ...state, loading: true }
        }
        case "LOADING_STOP": {
            return { ...state, loading: false }
        }
        case "REDUX_START": {
            return { ...state, redux: true }
        }
        case "SHOW_ALERT_MESSAGE": {
            return {
                ...state, alert: {
                    ...state.alert,
                    show: action.show,
                    message: action.message,
                    variant: action.variant
                }
            }
        }
        default:
            break;
    }
    return state;
}
